import React, { Component } from 'react';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import { bindActionCreators } from 'redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getTiposArticulo, modifyTipoArticulo, removeTipoArticulo, addTipoArticulo, updateTiposArticuloDB } from '../../actions/tipo_articulos_actions';
import { getTiposZona } from '../../actions/tipos_zona_actions'

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import * as config from '../../constants/configuration';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    marginBottom: {
        marginBottom: 20,
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeAuxiliaresTipoArticulo extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getTiposZona();
        this.props.getTiposArticulo();

    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkCvTipoArticulo = tipoArticulo => {
        if (this.props.tiposArticulo.find(c => (c.descr === tipoArticulo.descr) && (c.id !== tipoArticulo.id))) {
            this.messageDialog(`Ya existe un tipo de artículo ${tipoArticulo.descr}`);
            return false;
        } else if (!tipoArticulo.descr.trim()) {
            this.messageDialog('Por favor, introduzca una descripción');
            return false;
        }

        else return true;
    };

    editTipoArticulo = tipoArticulo => {
        this.props.openDialog('EditCvTipoArticulo', {
            cvTipoArticulo: tipoArticulo,
            checkCvTipoArticulo: this.checkCvTipoArticulo,
            okHandler: (ta) => {
                this.props.setSaveState(true);
                this.props.modifyTipoArticulo(ta);
            },
            tiposZona: this.props.tiposZona

        }, uuidv4());
    };

    newTipoArticulo = () => {
        this.props.openDialog('EditCvTipoArticulo', {
            cvTipoArticulo: {},
            okHandler: (ta) => {
                this.props.setSaveState(true);
                this.props.addTipoArticulo(ta);
            },
            checkCvTipoArticulo: this.checkCvTipoArticulo,
            tiposZona: this.props.tiposZona
        }, uuidv4());
    };

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {

        if (fromRow !== toRow) return; //solo modificamos una fila

        // for (let i = fromRow; i <= toRow; i++) {
        //     if (updated['isMovCaja']) updated['isMovCaja'] = 1;
        //     else updated['isMovCaja'] = 0;
        //     let updatedRow = update(this.props.tiposArticulo[i], { $merge: updated });
        //     this.props.setSaveState(true);
        //     this.props.modifyTipoArticulo(updatedRow);
        // };

        if (updated['isMovCaja']) updated['isMovCaja'] = 1;
        else updated['isMovCaja'] = 0;
        let updatedRow = update(this.props.tiposArticulo[fromRowData.grid_index], { $merge: updated });
        this.props.setSaveState(true);
        this.props.modifyTipoArticulo(updatedRow);

    };

    handleDeleteRow = tipoArticulo => {
        this.props.setSaveState(true);
        this.props.removeTipoArticulo(tipoArticulo);
    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <div className={classes.marginBottom}>

                    <NeuriteGrid
                        id="m_a_t_a"
                        columns={[
                            { key: 'descr', name: 'Descripción', dragable: false, width: 120 },
                            { key: 'cvTipoZonaDescr', name: 'Tipo Zona', tooltip: 'Zona generalmente asociada a este producto', dragable: false, width: 100 },
                            { key: 'isMovCaja', name: '¿Mov. Caja?', tooltip: 'Indica si es un concepto de caja (cobro/pago) o no (ingreso/gasto)', dragable: false, type: 'bool', width: 77 },
                            { key: 'iKind', name: 'iKind', dragable: false, type: 'int', width: 65, admin: true, },
                        ]}
                        rows={this.props.tiposArticulo}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newTipoArticulo}
                        onEditClick={this.editTipoArticulo}
                        onRowsUpdated={this.handleGridRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}

                    />

                </div>

                <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                    this.props.tiposArticulo.forEach(e => {
                        if (typeof e.id !== 'number') e.id = -1;
                    });

                    this.props.updateTiposArticuloDB(this.props.tiposArticulo)
                }}>Guardar</Button>
            </div >
        );

    };

};

MaeAuxiliaresTipoArticulo.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    tiposArticulo: PropTypes.array.isRequired,
    tiposZona: PropTypes.array.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getTiposZona: PropTypes.func.isRequired,
    getTiposArticulo: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    modifyTipoArticulo: PropTypes.func.isRequired,
    removeTipoArticulo: PropTypes.func.isRequired,
    addTipoArticulo: PropTypes.func.isRequired,
    updateTiposArticuloDB: PropTypes.func.isRequired
};

function mapStateToProps(state) {

    return {
        user: state.oidc.user,
        tiposArticulo: state.tiposArticulo.tiposarticulo,
        tiposZona: state.tiposZona.tiposzona,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getTiposArticulo,
        getTiposZona,
        openDialog,
        hideDialog,
        modifyTipoArticulo,
        removeTipoArticulo,
        addTipoArticulo,
        updateTiposArticuloDB,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeAuxiliaresTipoArticulo));

